/************************************
MODULE:         Mobile navigation
WHAT IT DOES:   Opening/closing/scrolling for mobile nav 
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else { root.returnExports = factory(root.jQuery); }
}(this, function ($) {
    var isInited = false,
        isOpened = false,
        tween = null,
        opener,
        menu,
        menuScroll,
        dropdown,
        html = $('html'),
        mainForm;

    function init() {
        if (isInited) {
            return;
        }
        isInited = true;

        header = $('.js-page-header');
        opener = $('.js-mobile-opener');
        menu = $('.js-mobile-navigation');
        menuScroll = menu.find('.js-mobile-navigation-inner');
        dropdown = menu.find('.js-login-dropdown');
        html = $('html');
        mainForm = $('body > form').first();

        if (!opener.length || !menu.length || !menuScroll.length) {
            return;
        }

        var tweenmax = require('tweenmax');
        var scrolltoplugin = require('scrolltoplugin');

        if (dropdown.length) {
            var genericdropdown = require('generic.dropdown');
            var link = dropdown.find('.js-dropdown-link'),
                content = dropdown.find('.js-dropdown-content');
            new genericdropdown(dropdown, {
                link: link,
                content: content,
                clickCallback: dropdownChange.bind(this, link, content),
                animationCallback: dropdownAnimated.bind(this, link, content)
            });
        }

        opener.on('click', openerClickProcess);
        $(window).on('resize:mobilemenu', resizeMobileMenu);
        $(window).on('resize:finished', resizeMobileMenu);
        $(window).on('orientationchange', scrollTopMobileMenu);
    }

    function dropdownChange(link, content) {        
        var scrollTop = Math.max(html[0].scrollTop, document.body.scrollTop),
            dropHeight = content.children().first().outerHeight(),
            top = menuScroll.outerHeight() - getHeight();

        tweenKill(tween);
        tween = new TimelineMax();

        if (dropdown.hasClass('opened')) {
            var top = Math.max(0, top + dropHeight),
                newHeight = Math.max(window.App.globals.height, menuScroll.outerHeight() + dropHeight);
            dropdown.css('margin-bottom', dropHeight);
            tween.to(window, 0.5, { scrollTo: { y: top } });
            tween.to(mainForm, 0.5, { minHeight: newHeight, maxHeight: newHeight }, "-=0.5");
        }
        else {
            var top = Math.max(0, top - dropHeight),
                newHeight = Math.max(window.App.globals.height, menuScroll.outerHeight() - dropHeight);
            tween.to(mainForm, 0.5, { minHeight: newHeight, maxHeight: newHeight });
            if (top < scrollTop) {
                tween.to(window, 0.5, { scrollTo: { y: top } }, "-=0.5");
            }
        }

        tween.play();
    }

    function dropdownAnimated(link, content) {
        if (!dropdown.hasClass('opened')) {
            dropdown.css('margin-bottom', '');
            resizeMobileMenu();
        }

    }

    function openerClickProcess(e) {
        if (typeof e != 'undefined' && typeof e.preventDefault == "function") {
            e.preventDefault();
        }

        if (isOpened)
            close();
        else
            open();
    }

    function getHeight() {
        return window.App.globals.height - window.App.globals.cookieRealHeight;
    }

    function resizeMobileMenu() {
        menu.css('min-height', !window.App.globals.isTabletSmall || !isOpened ? '' : getHeight());
        var height = !window.App.globals.isTabletSmall || !isOpened ? '' : menu.outerHeight();
        if(html.hasClass('fas-popup-opened')) height = '100vh';
        mainForm.css({
            'min-height': height,
            'max-height': height
        });
    }

    function scrollTopMobileMenu() {
        if (isOpened) {
            TweenMax.to(window, 0.5, {
                scrollTo: { y: 0 },
                delay: 0.5,
                onComplete: resizeMobileMenu
            });
        }
    }

    function open() {
        isOpened = true;

        tweenKill(tween);
        resizeMobileMenu();


        html.addClass('menu-opened');

        tween = new TimelineMax({ onComplete: animationComplete, ease: Power2.easeOut });
        tween.to(window, 0.5, { scrollTo: { y: 0 } });
        var formHeight = mainForm.outerHeight(),
            menuHeight = menu.outerHeight();
        tween.fromTo(mainForm, 0.5, { minHeight: formHeight }, { minHeight: menuHeight }, "-=0.5");
        tween.to(menu, 0.0, { visibility: 'visible' });
        if($('.custom-scroll').length)
            tween.to(header, 0.0, { position: 'fixed' });
        tween.to(menu, 0.5, { opacity: '1'});
        tween.play();
    }

    function close() {
        isOpened = false;

        tweenKill(tween);


        html.removeClass('menu-opened');
        if ($('.custom-scroll').length) {
            header.css({ position: 'initial' });
        }

        tween = new TimelineMax({ onComplete: animationComplete });
        tween.to(window, 0.5, { scrollTo: { y: 0 } });
        tween.to(menu, 0.5, { opacity: '0' });
        tween.to(menu, 0.0, { visibility: 'hidden' });
        tween.play();
        mainForm.css({
            'max-height': '',
            'min-height': menu.outerHeight()
        });
    }

    function animationComplete() {
        if (!isOpened) {
            menu.removeAttr('style');
            mainForm.removeAttr('style');
        } else {
            mainForm.css('max-height', menu.outerHeight());
        }
    }

    function tweenKill(tween) {
        if (typeof tween == 'undefined' || tween == null)
            return;

        if (typeof tween.progress == 'function' && tween.progress() < 1) {
            tween.pause();
            tween.progress(1);
        }

        if (typeof tween.destroy == 'function') {
            tween.destroy();
        }
    }

    return {
        init: init
    };

}));


/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.mobilenavigation.js
 ** module id = 45
 ** module chunks = 24
 **/